export default __webpack_public_path__ + "static/media/Karat-event.4d109f08.png";